import BaseEntity from "./BaseEntity";

export default class SalutationEntity extends BaseEntity {
    private _translatedNameWithPlaceholder: string;
    private _translatedSalutationFemaleWithPlaceholder: string;
    private _translatedSalutationMaleWithPlaceholder: string;
    private _kind: string;

    public get TranslatedNameWithPlaceholder(): string {
        return this._translatedNameWithPlaceholder;
    }

    public set TranslatedNameWithPlaceholder(value: string) {
        this._translatedNameWithPlaceholder = value;
    }

    public get TranslatedSalutationFemaleWithPlaceholder(): string {
        return this._translatedSalutationFemaleWithPlaceholder;
    }

    public set TranslatedSalutationFemaleWithPlaceholder(value: string) {
        this._translatedSalutationFemaleWithPlaceholder = value;
    }

    public get TranslatedSalutationMaleWithPlaceholder(): string {
        return this._translatedSalutationMaleWithPlaceholder;
    }

    public set TranslatedSalutationMaleWithPlaceholder(value: string) {
        this._translatedSalutationMaleWithPlaceholder = value;
    }

    public get Kind(): string {
        return this._kind;
    }

    public set Kind(value: string) {
        this._kind = value;
    }

    static fromOdata(odataItem: any, entity: SalutationEntity): SalutationEntity {
        super.fromOdata(odataItem, entity);
        entity.TranslatedNameWithPlaceholder = odataItem["TranslatedNameWithPlaceholder"];
        entity.TranslatedSalutationFemaleWithPlaceholder = odataItem["TranslatedSalutationFemaleWithPlaceholder"];
        entity.TranslatedSalutationMaleWithPlaceholder = odataItem["TranslatedSalutationMaleWithPlaceholder"];
        entity.Kind = odataItem["Kind"];
        return entity;
    }
}
